import { cellBrowsingSlice } from '../CellBrowsingSlice'
import useSliceWrapper from './useSliceWrapper'

const useGetMethodsAndData = () => useSliceWrapper('cellBrowsing', cellBrowsingSlice)

export const useCellBrowsingSlice = (): ReturnType<typeof useGetMethodsAndData> =>
  useGetMethodsAndData()

export default useCellBrowsingSlice
